import { render, staticRenderFns } from "./FTD.vue?vue&type=template&id=14867891&scoped=true"
import script from "./FTD.vue?vue&type=script&lang=js"
export * from "./FTD.vue?vue&type=script&lang=js"
import style0 from "./FTD.vue?vue&type=style&index=0&id=14867891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14867891",
  null
  
)

export default component.exports